import React from "react";
import { Img } from "components/Img";

const BrandingActionCard = ({ element, handleOpenDrawer, onDelete, isError }:any) => {
  // Get file type icon based on file extension or type
  const getFileIcon = (fileName) => {

    const extension = fileName?.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return "📄"; // PDF document
      case 'doc':
      case 'docx':
        return "📝"; // Word document
      case 'xls':
      case 'xlsx':
        return "📊"; // Excel spreadsheet
      case 'ppt':
      case 'pptx':
        return "📽️"; // PowerPoint presentation
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return "🖼️"; // Image file
      default:
        return "📁"; // Generic file
    }
    
  };

  return (
    <div
      className={`bg-[white] rounded-lg shadow-sm ${isError ? "border border-red-500" : "border border-gray-200"} py-3 px-4 h-full w-full flex items-center justify-between mt-2`}
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div onClick={() =>{
        if(!!handleOpenDrawer) handleOpenDrawer()
      }} className="flex items-center gap-3 flex-1 w-full cursor-pointer">
        {/* File Type Icon */}
        <div className="flex-shrink-0">
        {/* <Img src={getFileIcon(element?.MATERIAL_IMAGE?.selectedImage)} className="w-6 h-6" alt={element.fileType || "File"} />  */}
        <span className="text-[2.2vh]">{getFileIcon(element?.MATERIAL_IMAGE?.selectedImage)}</span>
        </div>

        {/* Material Name and Type */}
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-900 text-[2vh] truncate" title={element.MATERIAL_NAME}>
            {element.MATERIAL_NAME || "No, design my material"} 
            {element.MATERIAL_TYPE && (
              <span className="text-purple-primary text-[1.8vh] ml-1">
                ({element.MATERIAL_TYPE})
              </span>
            )}
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center space-x-2 ml-2">
        {!!onDelete && <button
          onClick={onDelete}
          className="text-gray-400 hover:text-red-600 p-1 rounded-full hover:bg-gray-100"
          type="button"
          aria-label="Delete document"
        >
          <img src="/images/trash.svg" alt="Delete" className="w-[2.7vh] h-[2.7vh]" />
        </button>}
      </div>
    </div>
  );
};

export default BrandingActionCard;